module.exports = __webpack_public_path__ + "img/sam-finish.8e744f74.jpg";